import { Grid } from '@mui/material';
import LocationAutocomplete from '../Inputs/Autocomplete/LocationAutocomplete';
import WorkingUnitAutocomplete from '../Inputs/Autocomplete/WorkingUnitAutocomplete';
import GridContainer from '../Layout/GridContainer';
import { Location } from '../../types/Location.interface';
import { WorkingUnit } from '../../types/WorkingUnit.interface';

export type WorkingUnitLocationAutocompleteProps = {
    locationOptions: Location[];
    selectedLocations: Location | Location[];
    onSelectedLocationsChange: (selectedLocations?: Location | Location[] | null) => void;
    workingUnitOptions: WorkingUnit[];
    selectedWorkingUnits: WorkingUnit | WorkingUnit[];
    onSelectedWorkingUnitsChange: (selectedWorkingUnits?: WorkingUnit | WorkingUnit[] | null) => void;
    isLocationMultiSelect?: boolean;
    isWorkingUnitMultiSelect?: boolean;
};

const WorkingUnitLocationAutocomplete = ({
    locationOptions,
    selectedLocations,
    onSelectedLocationsChange,
    workingUnitOptions,
    selectedWorkingUnits,
    onSelectedWorkingUnitsChange,
    isLocationMultiSelect,
    isWorkingUnitMultiSelect,
}: WorkingUnitLocationAutocompleteProps) => {
    return (
        <GridContainer>
            <Grid item xs={6}>
                <LocationAutocomplete
                    isMultiSelect={isLocationMultiSelect}
                    selectedLocation={selectedLocations}
                    locationOptions={locationOptions}
                    onChange={onSelectedLocationsChange}
                ></LocationAutocomplete>
            </Grid>
            <Grid item xs={6}>
                <WorkingUnitAutocomplete
                    isMultiSelect={isWorkingUnitMultiSelect}
                    selectedWorkingUnits={selectedWorkingUnits}
                    onChange={onSelectedWorkingUnitsChange}
                    workingUnitOptions={workingUnitOptions}
                ></WorkingUnitAutocomplete>
            </Grid>
        </GridContainer>
    );
};

export default WorkingUnitLocationAutocomplete;
